import { post, patch, get } from 'aws-amplify/api';
import { processResponse } from './api_util';
import useSWR from 'swr'




async function getCaseDocuments() {

  const payload = {
    apiName: 'DocumentApi',
    path: `document`

  }

  const restOperation = get(payload);


  const response = await restOperation.response;

  return processResponse(response)
}

export function useGetDocumentsForCurrentCase(shouldFetch = true) {
  const result = useSWR(
    shouldFetch ? ['DOCUMENTS'] : null,
    (path) => getCaseDocuments(),
    { refreshInterval: 5000 }
  );
  return result;
}

async function getCaseDocumentsStatusReport() {

  const payload = {
    apiName: 'DocumentApi',
    path: `document/status_report`

  }

  const restOperation = get(payload);


  const response = await restOperation.response;

  return processResponse(response)
}

export function useGetDocumentsStatusReport(shouldFetch = true) {
  const result = useSWR(
    shouldFetch ? ['DOCUMENTS_STATUS_REPORT'] : null,
    (path) => getCaseDocumentsStatusReport(),
    { refreshInterval: 5000 }
  );
  return result;
}

async function cancelDocument(documentId) {

  const payload = {
    apiName: 'DocumentApi',
    path: `document/${documentId}/cancel`
  }

  const restOperation = patch(payload);

  const response = await restOperation.response;

  return processResponse(response)
}

export function useCancelDocument() {
  // optimistically update the document status to "cancelling" before the API call completes
  const { data: documents, mutate } = useGetDocumentsForCurrentCase();

  const cancelDocumentAndUpdate = async (documentId) => {
    // optimistically update the document status to "cancelling"
    const updatedDocuments = documents.map(doc => {
      if (doc.document_id === documentId) {
        return { ...doc, status: 'CANCELED', displayStatus: 'Canceled' };
      }
      return doc;
    });
    mutate(updatedDocuments, false); // update local data without revalidation

    try {
      const response = await cancelDocument(documentId);
      mutate(response, false); // update with result from server without revalidation
    } catch (error) {
      console.error('Failed to cancel document:', error);
      mutate(); // revalidate to revert the optimistic update in case of error
    }
  }

  return cancelDocumentAndUpdate;
}

